'use strict';

class ProcedureTemplatesController {
    /* @ngInject */
    constructor(
        ProcedureTemplatesService,
        $scope,
        $q
    ) {
        Object.assign(this, {
            ProcedureTemplatesService,
            $scope,
            $q
        });

        this.query = {
            include: [],
            where: {},
            limit: 25,
            page: 1,
            order: 'name DESC'
        };

        this.getProcedureTemplates();

        this.onPagination = () => {
            this.getProcedureTemplates();
        };
    }

    getProcedureTemplates() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        if (this.whereName) {
            let id = parseInt(this.whereName, 10);
            if (isNaN(id)) {
                Object.assign(qOpts.where, {
                    name : {
                        ilike: `%${this.whereName}%`
                    }
                });
            } else {
                Object.assign(qOpts.where, {
                    id: id
                });
            }
        }

        let queryReady = this.ProcedureTemplatesService
            .getModels(qOpts)
            .then(procedureTemplates => {
                this.procedureTemplates = procedureTemplates;
            });
        let countReady = this.ProcedureTemplatesService
            .getCount(qOpts)
            .then(result => {
                this.procedureTemplatesCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

}

export default ProcedureTemplatesController;
